module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_bengtsfors-9c1f842dfa5cac91359a96f0924d6c32.png";